module.exports = __webpack_public_path__ + "img/axs.1411a4e4.svg";